module.exports = __webpack_public_path__ + "img/type_box_opening-side.e8647607.jpg";